// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout__layout___2TYIw"};